import { Layout as AntLayout, Breadcrumb, Button, Menu, PageHeader, Spin } from 'antd';
import dayjs from 'dayjs';
import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import { IGlobalState } from '~reducer';
import '../loan-payment-abas.less';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import menuDivider from '~UI/menuDivider';
import ILoanPaymentAba from '~Api/LoanPaymentAba/ILoanPaymentAba';
import { Dispatch } from 'redux';
import { loanPaymentAbaSelector } from '~LoanPaymentAbas/selectors';
import { loanPaymentAbaGetAction } from '~LoanPaymentAbas/actions';
import { Helmet } from 'react-helmet';
import _ from 'lodash';

export default function Layout(props: {
    breadcrumb?: JSX.Element;
    children: JSX.Element | JSX.Element[];
    section: string;
    pageTitle: string;
    uuid: string;
}): ReactElement {
    const { breadcrumb, children, section, uuid, pageTitle } = props;

    const dispatch: Dispatch = useDispatch();

    const loanPaymentAba: ILoanPaymentAba = useSelector((state: IGlobalState) => loanPaymentAbaSelector(state, uuid));

    useEffect(() => {
        if (!loanPaymentAba) {
            dispatch(loanPaymentAbaGetAction(uuid));
        }
    }, [
        dispatch,
        loanPaymentAba,
        uuid,
    ]);

    if (!loanPaymentAba) {
        return (
            <AntLayout className='loans'>
                <Breadcrumb className='breadcrumb'>
                    <Breadcrumb.Item>Home</Breadcrumb.Item>
                    <Breadcrumb.Item><Link to='/loans'>Loans</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><Link to='/loans/payment-abas/'>Loan Payment ABAs</Link></Breadcrumb.Item>
                </Breadcrumb>
                <Spin />
            </AntLayout>
        );
    }

    const breadcrumbBlock: JSX.Element = breadcrumb ? (
        <>
            <Breadcrumb.Item><Link to={`/loans/payment-abas/${loanPaymentAba.uuid}`}>{dayjs(loanPaymentAba.createdTime).format('DD/MM/YYYY HH:mm')}</Link></Breadcrumb.Item>
            {breadcrumb}
        </>
    ) : (
        <Breadcrumb.Item>{dayjs(loanPaymentAba.createdTime).format('DD/MM/YYYY HH:mm')}</Breadcrumb.Item>
    );

    const extra: JSX.Element = (
        <Button
            href={`${process.env.API_HOST}/loan-payment-abas/${loanPaymentAba.uuid}/download`}
            target='_blank'
        >ABA File</Button>
    );

    const menuItems: ItemType[] = [
        {
            key: 'transactions',
            label: <NavLink to={`/loans/payment-abas/${loanPaymentAba.uuid}/transactions`}>Transactions</NavLink>,
        },
        menuDivider,
        {
            key: 'history',
            label: <NavLink to={`/loans/payment-abas/${loanPaymentAba.uuid}/history`}>History</NavLink>,
        },
    ];

    return (
        <AntLayout className='loan-payment-aba'>
            <Helmet>
                <title>{dayjs(loanPaymentAba.createdTime).format('DD/MM/YYYY HH:mm')} &nbsp;/&nbsp; {pageTitle}</title>
            </Helmet>
            <Breadcrumb className='breadcrumb'>
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item><Link to='/loans'>Loans</Link></Breadcrumb.Item>
                <Breadcrumb.Item><Link to='/loans/payment-abas/'>Loan Payment ABAs</Link></Breadcrumb.Item>
                {breadcrumbBlock}
            </Breadcrumb>
            <PageHeader
                className='header'
                extra={extra}
                ghost={false}
                title={dayjs(loanPaymentAba.createdTime).format('DD/MM/YYYY HH:mm')}
            />
            <AntLayout className='content-wrapper'>
                <AntLayout.Sider className='menu' theme='light' width={240}>
                    <Menu
                        defaultSelectedKeys={[ section ]}
                        items={menuItems}
                        mode='inline'
                    />
                </AntLayout.Sider>
                <AntLayout.Content className={`content ${section}`}>
                    {children}
                </AntLayout.Content>
            </AntLayout>
        </AntLayout>
    );
}
